
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
// import logo from '../images/logo.png';

function Index() {
	const location = useLocation();

	const appTitle = import.meta.env.VITE_TITLE;
	const description = import.meta.env.VITE_DESCRIPTION;
	const logo = import.meta.env.VITE_LOGO;

	return <>

		<div className="pricing-header p-3 pb-md-4 mx-auto text-center">
			<img src={logo} alt={appTitle} className="logo" />
			<h1 className="display-5 fw-normal" style={{ textWrap: 'pretty' }}>Welcome to {appTitle}</h1>
			<p className="fs-5">{description}</p>
			<p className="lead mt-5">
				<Link to={`/signin${location.search}`} className="btn btn-lg btn-primary fw-bold me-sm-3 me-0 mb-3 mb-sm-0 shadow btn-welcome">Sign In</Link>
				<Link to={`/pricing${location.search}`} className="btn btn-lg btn-secondary fw-bold border-white bg-white shadow btn-welcome">See Pricing</Link>
			</p>
		</div>

	</>
}

export default Index